import React from "react";
import { FiCheck, FiX } from "react-icons/fi";
import { Input } from "../Input";
import {
  CustomFieldContainer,
  CustomFieldRow,
  CustomFieldLabel,
  CustomFieldValue,
  CustomFieldActions,
  ActionButton,
  ResultLabel,
} from "./styles";

interface CustomFieldFormProps {
  customFieldName: string;
  customFieldValue: string;
  errors: Record<string, string>;
  onNameChange: (value: string) => void;
  onValueChange: (value: string) => void;
  onSave: () => void;
  onCancel: () => void;
}

export const CustomFieldForm: React.FC<CustomFieldFormProps> = ({
  customFieldName,
  customFieldValue,
  errors,
  onNameChange,
  onValueChange,
  onSave,
  onCancel,
}) => {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      onSave();
    }
  };

  return (
    <CustomFieldContainer>
      <ResultLabel>Add Custom Field</ResultLabel>
      <CustomFieldRow>
        <CustomFieldLabel>
          <Input
            value={customFieldName}
            onChange={(e) => onNameChange(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Field name"
            error={errors.customFieldName}
            autoFocus
          />
        </CustomFieldLabel>
        <CustomFieldValue>
          <Input
            value={customFieldValue}
            onChange={(e) => onValueChange(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Field value"
          />
        </CustomFieldValue>
        <CustomFieldActions>
          <ActionButton onClick={onSave} title="Save">
            <FiCheck size={18} color="green" />
          </ActionButton>
          <ActionButton onClick={onCancel} title="Cancel">
            <FiX size={18} color="red" />
          </ActionButton>
        </CustomFieldActions>
      </CustomFieldRow>
    </CustomFieldContainer>
  );
};
